import React from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import Slider from 'react-slick';
import './revies.css';
import gyasu from '../images/gyasu.png';

const reviews = [
  {
    name: "Sonal",
    service: "Web Development",
    comment: "The web development service exceeded all expectations. They delivered a fully responsive, SEO-optimized website that perfectly matches our brand. Communication was clear and timely, and the final product boosted our online presence significantly. Truly professional and skilled team!",
    rating: 5,
    image: "https://randomuser.me/api/portraits/women/65.jpg"
  },
  {
    name: "Ashish Gupta",
    service: "SEO & Performance Optimization",
    comment: "After their SEO work, our website traffic increased dramatically. Their optimization techniques really work, and the team is very knowledgeable. Highly recommended for anyone wanting better online visibility.",
    rating: 5,
    image: "https://randomuser.me/api/portraits/men/75.jpg"
  },
  {
    name: "Neha Gupta",
    service: "Website Maintenance & Support",
    comment: "Reliable and quick support for website issues. They keep our site updated, secure, and running smoothly, allowing us to focus on our business without worrying about technical glitches.",
    rating: 5,
    image: "https://randomuser.me/api/portraits/women/72.jpg"
  },
  {
    name: "Gyasuddin Ali",
    service: "Plumbing",
    comment: "Very punctual and professional. Fixed our bathroom leak within an hour. Will definitely use again.",
    rating: 5,
    image: gyasu
  },
  {
    name: "Raaz.",
    service: "Painting",
    comment: "The painter did an amazing job on our bedroom walls. Clean finish and no mess left behind!",
    rating: 4,
    image: "https://randomuser.me/api/portraits/men/44.jpg"
  },
  {
    name: "Amit",
    service: "Appliance Repair",
    comment: "Quick diagnosis and fixed my fridge the same day. Appreciate the honesty and fair pricing.",
    rating: 5,
    image: ""
  },
  {
    name: "Shams.",
    service: "Cleaning",
    comment: "The cleaning crew was thorough and efficient. My home feels brand new!",
    rating: 4,
    image: "https://randomuser.me/api/portraits/men/12.jpg"
  }
];

const StarRating = ({ rating }) => (
  <div className="stars">
    {Array.from({ length: 5 }, (_, i) => (
      <span key={i} className={i < rating ? 'filled' : ''}>★</span>
    ))}
  </div>
);

const Review = () => {
 const settings = {
  dots: true,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 4000,
  pauseOnHover: true,     
  speed: 600,
  slidesToShow: 2,      
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 768, 
      settings: {
        slidesToShow: 1
      }
    },
    {
      breakpoint: 1024, 
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 3
      }
    }
  ]
};


  return (
    <div className="reviews-container">
      <h2 className="text-center rounded py-2" style={{ color: '#d4af37', backgroundColor: '#0b3d2e' }}>
        Customer Reviews
      </h2>

      <Slider {...settings}>
        {reviews.map((review, index) => (
          <div key={index} className="review-card text-center px-3 py-4">
            <img
              src={review.image}
              alt={review.name || 'Customer'}
              className="review-image"
              // onError={(e) => (e.target.src = defaultAvatar)}
            />
            <div className="review-content">
              <h5 className="text-success">{review.service}</h5>
              <p className="fw-bold mb-1 text-dark">{review.name}</p>
              <StarRating rating={review.rating} />
              <p className="fst-italic text-dark">“{review.comment}”</p>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Review;
